import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { ErrorMessageComponent } from '../error-message/error-message.component';
import { FormControl, FormGroup } from '@angular/forms';
import { ValidationService } from '../validation.service';
import {environment} from "../../../../environments/environment";

@Component({
  selector: 'app-sms-code-field',
  templateUrl: './sms-code-field.component.html',
  styleUrls: ['./sms-code-field.component.sass'],
})
export class SmsCodeFieldComponent {
  @ViewChild(ErrorMessageComponent) error;

  @Input() fieldName: string;
  @Output() completed: EventEmitter<any> = new EventEmitter<any>();
  @Input() formGroup: FormGroup;
  @Input() size: number = 4;
  @Input() loading?: boolean = false;
  @Input() disableRequiredIdentifier: boolean = false;

  public brand = environment.brand;

  public get control() {
    return this.formGroup.get(this.fieldName) as FormControl;
  }

  public complete() {
    this.completed.emit();
  }

  public validation() {
    return ValidationService.getValidationClass(
      this.formGroup.get(this.fieldName) as FormControl, this.brand, this.disableRequiredIdentifier
    );
  }
}
